import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={9}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Technology Stack for <span>Vendor Portal</span> Development
            </h2>
            <p>
              Our vendor portal solutions are crafted using the latest,
              high-demand technologies, guaranteeing exceptional performance,
              scalability, and security at every stage of development.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/Angular_JS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Angular JS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/frontend/Ember.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Ember</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/CSS3.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>CSS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/HTML5.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>HTML5</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/JavaScript.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>JavaScript</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/React.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>React</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/frontend/Meteor.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Meteor</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/frontend/Vue.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>VueJs</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/backend/Go.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Go</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/backend/Microsoft.Net.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Microsoft.Net</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/backend/php.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>PHP</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/Java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/Node.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Node JS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/progressive-web/backend/Python.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="CMS">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/cms/Drupal.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Drupal</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/cms/Joomla.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Joomla</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/cms/Pimcore.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Pimcore</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/cms/SharePoint.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>SharePoint</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/cms/WordPress.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>WordPress</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="CRM">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/crm/Dynamic_365.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Dynamic 365</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/crm/Hubspot.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Hubspot</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/crm/ORO.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>ORO</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/crm/Salesforce.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Salesforce</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/crm/Zendesk.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Zendesk</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Cloud & DevOps">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/cloud-devops/AWS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/cloud-devops/Docker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/cloud-devops/Jenkins.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Jenkins</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/cloud-devops/Kubernetes.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Kubernetes</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/vendor-portal/cloud-devops/microsoft_azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={90}
                    height={90}
                  />
                  <div className="text_tabs_web">
                    <h6>Microsoft Azure</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
